module.exports = __webpack_public_path__ + "media/images/recruit/credo/img-business-description_sp-138e9feda6eb7174056a81180a2e7a08.svg";